// User search sagas
import { put } from 'redux-saga/effects';
import type { Action } from 'redux-actions';

// Services
import { ErrorCategory, handleError } from '@services/errorService';

// Api
import client from '@api';

// Actions
import { UsersSearch, UsersSearchResult } from '@actions/search';

import { getUsersByName } from '../../graphql/queries/account';

import type { FindUserByNameResponse, UsersSearchPayload } from './types';

export function* getUsersByNameSaga({
  payload: { searchString },
}: Action<UsersSearchPayload>): Generator<unknown, void, unknown> {
  try {
    const response = (yield client().query({
      query: getUsersByName,
      variables: { searchString },
      fetchPolicy: 'network-only',
    })) as FindUserByNameResponse;

    yield put(UsersSearchResult({ users: response.data.findUserByName }));
  } catch (error) {
    handleError(error, { category: ErrorCategory.AUTH });
  }
}

// Action creators for watchers
export const searchActions = {
  UsersSearch,
};
